module.exports = __webpack_public_path__ + "img/goods14_3.80e3ce5a.jpg";